import { ApplicationRef, ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { UserIdleService } from 'angular-user-idle';
import { AddToHomeScreenComponent } from './add-to-home-screen/add-to-home-screen.component';
import { MaterialDialogComponent } from './matdialog/matdialog.component';
import { SharedService } from './services/shared.service';
import { filter } from 'rxjs/operators';

declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private readonly publickey =
    'BHi3wD-JN9gnNH8vR_Gs9I-zX8_N9aoq9Ebfzr3flCcsUcWiF-a-pui47IXeon2WzIQ6XqkQsSI7TDIlOccz8CY';
    previousUrl: string = null;
    currentUrl: string = null;
    isDesktop: boolean;
    backtoDashboard: any;
    backtoDashboardObj: any = {
      homeScreenIndex: 0
    };

  private readonly privatekey = 'WKrIZTJniR4SelVcofitcVNjKPeRkY7rQ1aWxWc-_fM';
  isLoading: boolean;
  constructor(
    private userIdle: UserIdleService,
    private sharedService: SharedService,
    private dialog: MatDialog,
    private update: SwUpdate,
    private snackbar: MatSnackBar,
    private appRef: ApplicationRef,
    private router: Router,
    private renderer: Renderer2,
    private swPush: SwPush,
    private ref: ChangeDetectorRef,
    private _elementRef: ElementRef
  ) {
    this.isDesktop = this.sharedService.isNotMobile();
  }
  ngOnInit() {
    this.pushSubscription();
    this.sharedService.scLogin = this.getSCLogin();
    this.sharedService.choLogin = this.getCHOLogin();
    this.swPush.messages.subscribe((msg) => {
      console.log(msg);
    });

    this.router.events.pipe(filter((evt) => evt instanceof NavigationEnd)).subscribe((evt: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = evt .url;
      if(this.previousUrl && !this.previousUrl.includes('/portal/patientsummary/') && !this.currentUrl.includes('/portal/patientsummary/')) {
        sessionStorage.removeItem('preloadwebfilter')
        this.sharedService.searchPayloadInfoWeb = {}
        this.sharedService.searchresultWeb = {
          results : [],
          hasTooManyRecords: false
        }
      }
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.router.events.pipe(filter((evt) => evt instanceof NavigationStart)).subscribe((evt: NavigationStart) => {
      if(!this.isDesktop && evt.navigationTrigger === 'popstate') {
      
        if(this.backtoDashboard) {
          this.backtoDashboardObj.homeScreenIndex = 1;
        }

        // Back history 
        if ((window.location.href.includes('/portal/patientsummary/home') || window.location.href.includes('/portal/patientsummary/Profile'))  && this.sharedService.patientfamilydata.length > 0 ) {
          
            if(this.sharedService.skipPwaBackHistory && window.location.href.includes('/portal/patientsummary/home')) {

              this.router.navigate(['/portal/patientsummary/home']);
            
            } else if(window.location.href.includes('/portal/patientsummary/Profile')) {
            
              const patientfamilydataLastVal = this.sharedService.patientfamilydata.length - 1
              sessionStorage.setItem('patientsummary', JSON.stringify(this.sharedService.patientfamilydata[patientfamilydataLastVal]));
              this.sharedService.setCookie('patientsummary', JSON.stringify(this.sharedService.patientfamilydata[patientfamilydataLastVal]));
              this.sharedService.loadleftPanel.emit({ isProfileReload: true, summary: this.sharedService.patientfamilydata[patientfamilydataLastVal] });
            
            } else if (window.location.href.includes('/portal/patientsummary/home')) {
              this.sharedService.patientfamilydata.pop()
            } 

            this.sharedService.skipPwaBackHistory = false
            sessionStorage.setItem('locationHash', JSON.stringify(window.location.hash))
        
        } 
        
        else if (sessionStorage.passingThroughfamilyMember && sessionStorage.passingThroughfamilyMember == 'yes' && this.sharedService.patientfamilydata.length == 0 && window.location.href.includes('/portal/patientsummary/home')) {
        
          this.router.navigate(['/portal'])
          sessionStorage.removeItem('passingThroughfamilyMember')
        
          if(this.backtoDashboard) {
            this.backtoDashboardObj.homeScreenIndex = 1;
          }
    
        } else {
        
          this.router.navigate(['/portal']);
          this.backtoDashboardObj.homeScreenIndex = 1;
        
        }
      
      }
    });

    this.sharedService.refreshToken();
    // Start watching for user inactivity.
    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe((count) => {});

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      sessionStorage.clear();
      this.sessionout();
    });
    this.userIdle.ping$.subscribe(() => {
      this.sharedService.refreshToken();
    });
    document.body.addEventListener('click', () => {
      this.restart();
    }, true); 
    let deferredPrompt;

    if (this.sharedService.isMobile()) {
      this.renderer.addClass(document.body, 'body-mobile');
      this.checkUpdate();
      this.updateClient();
      window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        deferredPrompt = e;
        // Update UI to notify the user they can add to home screen

        // const snack = this.snackbar.open('PHC APP', 'Add to Home Screen');
        // snack.onAction().subscribe(() => {
        //   deferredPrompt.prompt();
        // });

        this.snackbar.openFromComponent(AddToHomeScreenComponent, {
          data: deferredPrompt,
        });

        // Show the prompt

        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
            window.location.reload();
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          deferredPrompt = null;
        });
      });
    }
    this.sharedService.isLoading$.subscribe((res) => {
      this.isLoading = res;
      // this.ref.detectChanges();
    });
    //Remove ng-version attribute from DOM
    this._elementRef.nativeElement.removeAttribute("ng-version");
  }

  stop() {
    this.userIdle.stopTimer();
  }

  stopWatching() {
    this.userIdle.stopWatching();
  }

  startWatching() {
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
  }
  getSCLogin() {
    if (
      this.sharedService.getLocationParams().authorities &&
      this.sharedService.getLocationParams().authorities.includes('SUBCENTER_PORTAL_LOGIN')
    ) {
      return true;
    }
    return false;
  }

  getCHOLogin() {
    if (
      this.sharedService.getLocationParams().authorities &&
      this.sharedService.getLocationParams().authorities.includes('AUTHORITY_EDT')
    ) {
      return true;
    }
    return false;
  }

  updateClient() {
    if (!this.update.isEnabled) {
      console.log('not enabled');
      return;
    }
    this.update.available.subscribe(() => {
      const snack = this.snackbar.open('Update Available', 'Reload');
      snack.onAction().subscribe(() => {
        this.update.activateUpdate().then(() => location.reload());
      });
    });
    this.update.activated.subscribe(() => {
      // console.log('current', event.previous, 'available', event.current);
    });
  }

  checkUpdate() {
    this.appRef.isStable.subscribe((isStable) => {
      if (!isStable) {
        setTimeout(() => {
          this.update.checkForUpdate().then(() => {
            // console.log('update checked');
          });
        }, 10000);
      }
    });
  }

  pushSubscription() {
    if (!this.swPush.isEnabled) {
      console.log('Notification is not enabled');
      return;
    }
    this.swPush
      .requestSubscription({
        serverPublicKey: this.publickey,
      })
      .then((sub) => {
        console.log(JSON.stringify(sub));
      })
      .catch((err) => console.log(err));
  }

  sessionout() {
    const dialogRef = this.dialog.open(MaterialDialogComponent, {
      data: {
        title: 'Your session has expired. Please login again.',
        yesButtonName: 'OK',
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.userIdle.stopWatching();
      this.dialog.closeAll();
      this.sharedService.redirectToLogin();
    });
  }

  elearning() {
    $('#Elearning').modal('show');
  }
}
